// organize-imports-ignore
import './src/lib/patch-reanimated';
import 'react-native-reanimated';
import 'expo-dev-client';
import 'expo/build/Expo.fx';
import 'expo-asset';
import '@expo/match-media';
import 'react-native-gesture-handler';
import 'react-native-console-time-polyfill';
import { enableAllPlugins } from 'immer';
import { Platform, Text, TextInput } from 'react-native';
import { registerRootComponent } from 'expo';
import { setup } from '@euler/lib';

// disable system font scaling
Text.defaultProps = Text.defaultProps || {};
Text.defaultProps.allowFontScaling = false;

TextInput.defaultProps = TextInput.defaultProps || {};
TextInput.defaultProps.allowFontScaling = false;

import App from './src/App';

if (Platform.OS === 'web') {
  // Fix reanimated '_frameTimestamp is not defined' error,see:
  // https://github.com/software-mansion/react-native-reanimated/issues/3355
  // eslint-disable-next-line no-undef
  const w = window;
  w._frameTimestamp = null;

  if (!w.setImmediate) {
    w.setImmediate = w.requestAnimationFrame;
  }

  // eslint-disable-next-line no-undef
  if (navigator.userAgent.indexOf('Windows') != -1) {
    // eslint-disable-next-line no-undef
    document.documentElement.classList &&
      // eslint-disable-next-line no-undef
      document.documentElement.classList.add('windows');
  }
} else {
  require('react-native-url-polyfill/auto');
}

enableAllPlugins();
setup();

// registerRootComponent calls AppRegistry.registerComponent('main', () => App);
// It also ensures that whether you load the app in Expo Go or in a native build,
// the environment is set up appropriately
registerRootComponent(App);
